import { ChartLineVariantIcon } from './ChartLineVariantIcon';

/**
 * author: Google
 * id 2FAF8E0B-5AB4-4914-A0A1-CECFFAF85427
 * name chart-line-variant
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-line-variant.svg
 * tags
 * - Math 
 */
export const GraphLineVariantIcon = ChartLineVariantIcon;
export default GraphLineVariantIcon